
import { motion } from 'framer-motion';
import { Header } from './Header';
import { Footer } from './Footer';

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
}

export function PageLayout({ children, className = '', title, subtitle }: PageLayoutProps) {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <motion.main
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className={`flex-grow pt-24 ${className}`}
      >
        {(title || subtitle) && (
          <div className="container px-4 mb-8">
            {title && <h1 className="text-3xl font-bold tracking-tight">{title}</h1>}
            {subtitle && <p className="text-muted-foreground mt-2">{subtitle}</p>}
          </div>
        )}
        {children}
      </motion.main>
      <Footer />
    </div>
  );
}
